import { UserTechnicalSalesRepository } from './infra/repository/user-technical-sales.repository'
import { SendProductInfoRequestUseCase } from './domain/use-case/send-product-info-request.use-case'
import { getConfig } from '@b2ag/micro-front-tools'

const technicalSalesRepository = new UserTechnicalSalesRepository(getConfig('USER_API_HOST'))
const sendProductInfoRequestUseCase = new SendProductInfoRequestUseCase(technicalSalesRepository)

export { sendProductInfoRequestUseCase }
